import axios from "axios";
import { get, post } from "./index";
//const url = "/zn";
const url = "/vpp/api";

export class firstApi {
  //token 认证
  static verifyToken() {
    return get(url + "/sign/verifyToken");
  }
  static saveExamSign(data) {
    return post(url + "/sign/saveExamSign", data);
  }
  //sign/initFaceVerify 认证阿里
  static initFaceVerify(data) {
    return post(url + "/sign/loginMiniSign", data);
  }
  //认证成功查询头像 /sign/queryFaceVerifyImage
  static queryFaceVerifyImage(data) {
    return get(url + "/sign/queryFaceVerifyImage", data);
  }
  static uploadPdf(data) {
    return post(url + "/constantVolumeAnalysis/uploadPdf", data);
  }
  //oss 阿里云服务获取资源
  static getKeyIdAndSecret(data) {
    return post(url + "/getKeyIdAndSecret", data);
  }
  // 获取用户历史
  static getUserList(data) {
    return post(url + "/constantVolumeAnalysis/getUserList", data);
  }

  //启用停用
  static sysUserSor(data) {
    return get(url + "/sysUser/sor?id=" + data);
  }
  //上传
  static uploadPdfHD(data) {
    return axios.post(url + "/constantVolumeAnalysis/uploadPdf", data, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
      timeout: 60000, // 设置超时时间为 60 秒
      onUploadProgress: function (progressEvent) {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log(`Upload progress: ${percentCompleted}%`);
      },
      //signal, // 添加 signal 参数来支持取消请求
    });
  }
  //下载文件
  static apiFilesDownload(data) {
    console.log(data);
    return axios({
      method: "post",
      // url: url + "/api/files/download?fileId=" + data.fileId+"&fileName="+data.fileName,
      url: url + "/api/files/download",
      data: data,
      responseType: "blob",
    });
  }
  //saveUser
  static saveUser(data) {
    return post(url + "/saveUser", data);
  }
  //签到成功获取 签到详情/sign/f，GET，传参：certifyId
  static querySignSuccessExamSign(data) {
    return get(url + "/sign/querySignSuccessExamSign", data);
  }
  ///agreement/getContract，GET，获取协议
  static getContract(data) {
    return get(url + "/agreement/getContract", data);
  }
  ////sign/initFaceVerifyBack
  static initFaceVerifyBack(data) {
    return post(url + "/sign/initFaceVerifyBack", data);
  }
  ///proctor/plan/initFaceVerify，监考端-复核发起认证，POST，传参：enrollId，metaInfoVo
  static planInitFaceVerify(data) {
    return post(url + "/proctor/plan/initFaceVerify", data);
  }
  ///faceVerifyCallBack，GET，传参：certifyId，后端下载人脸图片供小程序展示
  static faceVerifyCallBack(data) {
    return get(url + "/sign/faceVerifyCallBack", data);
  }
}
